// ANSI Shadow Effect
export default function EasterEggs() {
    console.log(`
██████╗  ██████╗ ██╗     █████╗  ██████╗ ███████╗███╗   ██╗ ██████╗██╗   ██╗
██╔══██╗██╔═══██╗██║    ██╔══██╗██╔════╝ ██╔════╝████╗  ██║██╔════╝╚██╗ ██╔╝
██████╔╝██║   ██║██║    ███████║██║  ███╗█████╗  ██╔██╗ ██║██║      ╚████╔╝ 
██╔══██╗██║   ██║██║    ██╔══██║██║   ██║██╔══╝  ██║╚██╗██║██║       ╚██╔╝  
██║  ██║╚██████╔╝██║    ██║  ██║╚██████╔╝███████╗██║ ╚████║╚██████╗   ██║   
╚═╝  ╚═╝ ╚═════╝ ╚═╝    ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚═╝  ╚═══╝ ╚═════╝   ╚═╝   

               Return On Investment
`);


    console.log("Curious? contact roi-agency.dev@gmail.com to join us")
}
